import React, {useMemo, useEffect, useContext} from 'react';
import useForm from 'hooks/useForm';
import {fieldsForm, schema} from './fields';
import { useMutation } from "@apollo/client";
import { VERIFY } from "schemas/register";
import {Button, Form} from 'react-bootstrap';
import RegisterContext from '../../RegisterContext';

export default function SendPasswordStep({labels}) {

  const {user,refetchUser, goToStepsProcess} = useContext(RegisterContext)

  const {
    formik,
    renderElementsForm,
    renderElement
  } = useForm({
      fieldsForm,
      schema,
      onSubmit: handleSubmit
  })

  const formElements = useMemo(() => renderElementsForm(), [fieldsForm]);

  function sendPasswordAgain() {
    alert('send pass');
  }

  const [verify, { data, error }] = useMutation(VERIFY);

  function handleSubmit(values) {
    verify({
      variables: values
    })
  }

  useEffect(() => {
    if (data) {
      refetchUser()
      goToStepsProcess()
    }
    if (error) {
      formik.setFieldError('password',error.message)
    }
  }, [data, error])

  return (
    <>
      <h3>שלום {user.firstName}</h3>
        <p className="mb-5 medium-font">שלחנו לך לטלפון הנייד סיסמא זמנית, הקלדי את הסיסמא ונשחזר את הפרטים</p>
        <Form onSubmit={formik.handleSubmit}>
        {formElements.map((el, index) =>
            renderElement(el,labels)
          )}
        <Button  className="btn_submit " aria-label="כניסה" variant="dark" type="submit">כניסה</Button>
        <Button className="normal-font" aria-label="לשליחה חוזרת" variant="link" onClick={sendPasswordAgain}>לשליחה חוזרת</Button>

        </Form>

    </>
  )
}